document.addEventListener("quick-view:open", function (evt) { 
  const productHanlde = evt.detail.productHandle,
        quickViewContent = document.querySelector('.quick__view-inner-content');
  
  if(quickViewContent) {
    toggleVariantElem( productHanlde )

    document.querySelectorAll('[data-product-variant-change-quick-view]').forEach(element => {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        const handle = this.getAttribute('data-product-handle');
        toggleVariantElem( handle )
        console.log("handle", handle)
      })
    })
  }

  function toggleVariantElem( productHanlde){
    if(productHanlde) {
      quickViewContent.classList.add("hidden__element");
      document.querySelectorAll('.quick__view-inner-content').forEach((elem) => {
        if(elem.getAttribute('data-product-handle') === productHanlde ) {
          let selectedSwatchElem = elem.querySelector(`[data-product-handle="${productHanlde}"]`),
              selectedSwatch = capitalize(selectedSwatchElem.getAttribute('data-swatch-color'));

          elem.classList.remove("hidden__element");
          elem.querySelector('.form__label__value').innerText = selectedSwatch;
        } else {
          elem.classList.add("hidden__element");
        }    
      });
    }
  }

  function capitalize(sentence) {
    if(!sentence) return;
    return sentence.split(' ').map(word => word[0].toUpperCase() + word.slice(1)).join(' ');
  }
 
});